

<template>
    <div :class="['arrival-departure-picker', displayMode, {'for-accommodation':isForAccommodation, 'picking-arrival':isPickStateArrival, 'picking-departure': isPickStateDeparture }]" ref="root">

        <div class="picker-title">{{arrivalDeparturePicker_Title_ChooseArrDept}}</div>

        <div class="calendar-control-container">

            <button class="btn-prev"></button>
            <button class="btn-next"></button>
        </div>

        <div class="adp-months-container" @click="onDayClick">

            <month v-for="month in months" :month="month"></month>
        </div>

        <input type="hidden" v-model="arrivalDateInput" name="Date.Min" class="arrival-input" />
        <input type="hidden" v-model="departureDateInput" name="Date.Max" class="departure-input" />

        <div class="departure-date-info" v-if="arrivalDateInput && !departureDateInput">{{arrivalDeparturePicker_Label_ChooseDeptToContinue}}</div>

        <div class="action-buttons">
            <button v-if="showClearButton" 
                    type="button" 
                    class="btn btn-secondary reset-date"
                    :class="{'can-perform': hasArrivalDate, 'btn-secondary':!displayConstrained, 'btn-outline-dark':displayConstrained}"
                    @click="resetDate">{{arrivalDeparturePicker_Btn_ResetDate}}</button>
            <button v-else-if="!hideNoPreferenceButton" type="button" class="btn btn-primary no-date-pref-btn" @click="noDatePreference">{{arrivalDeparturePicker_Btn_NoDatePreference}}</button>
        </div>
    </div>


</template>


<script src="./arrivalDeparturePicker.ts"></script>
<style src="./arrivalDeparturePicker.css"></style>
